import React, { FunctionComponent } from "react";

type HeroTitleProps = {
  className?: string;
  dark?: boolean;
};

const HeroTitle: FunctionComponent<HeroTitleProps> = ({
  children,
  className,
  dark = false,
}) => {
  return (
    <h1
      className={`${className} max-w-prose text-5xl leading-10 md:text-7xl md:leading-[3.8rem] tracking-tight  font-extrabold ${
        dark ? "text-white" : "text-gray-900"
      }`}
    >
      {children}
    </h1>
  );
};

export default HeroTitle;
